import { buildUrl, handleFileRequest, handleRequest } from '@common/services/requestHelper';
import { RequestType } from '@common/services/types';
import { DocumentType, Id } from '@common/types';

const basePath = process.env.REACT_APP_API_PATH;

const fetchSubmissionTaskList = async (queryString: string) => {
  const url = buildUrl('/submission-task', basePath, queryString);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchSubmissionTaskData = async (taskId: string) => {
  const url = buildUrl(`/submission-task/${taskId}`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchSubmissionTaskNextStatuses = async (taskId: Id, queryString: string) => {
  const url = buildUrl(`/submission-task/${taskId}/next-statuses`, basePath, queryString);

  return handleRequest({ url, requestType: RequestType.GET });
};

const putSubmissionTaskStatus = async (taskId: string, dataSet: unknown) => {
  const url = buildUrl(`/submission-task/${taskId}/status`, basePath);

  return handleRequest({ url, requestType: RequestType.PUT, data: dataSet });
};

const fetchSubmissionTaskNotes = async (taskId: string) => {
  const url = buildUrl(`/submission-task/${taskId}/notes`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchSubmissionTaskProductGroupData = async (taskId: string) => {
  const url = buildUrl(`/submission-task/${taskId}/product-group`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const resubmitSubmissionTask = async (taskId: string, dataSet: unknown) => {
  const url = buildUrl(`/submission-task/${taskId}/resubmit`, basePath);

  return handleRequest({ url, requestType: RequestType.PUT, data: dataSet });
};

const validateSubmissionTask = async (taskId: Id) => {
  const url = buildUrl(`/submission-task/${taskId}/validate`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchHtml = async (taskId: string) => {
  const url = buildUrl(`/submission-task/${taskId}/html`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const downloadTaskHtmlAsPdf = async (taskId: Id) => {
  const url = buildUrl(`/submission-task/${taskId}/html-as-pdf`, basePath);

  return handleFileRequest({ url, requestType: RequestType.GET });
};

const fetchSlaAlerts = async () => {
  const url = buildUrl('/submission-task/sla-alerts', basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const getPublishedDocument = async (
  documentId: string,
  version: string,
  documentType: DocumentType,
  queryString: string,
  handleAsFileStream: boolean,
  propagateNotFound?: boolean,
) => {
  const url = buildUrl(`/document/${documentId}/version/${version}/document-type/${documentType}`, basePath, queryString);

  return handleAsFileStream
    ? handleFileRequest({ url, requestType: RequestType.GET, propagateNotFound: propagateNotFound })
    : handleRequest({ url, requestType: RequestType.GET, propagateNotFound: propagateNotFound });
};

export {
  fetchSubmissionTaskList,
  fetchSubmissionTaskData,
  putSubmissionTaskStatus,
  fetchSubmissionTaskNotes,
  fetchSubmissionTaskProductGroupData,
  resubmitSubmissionTask,
  validateSubmissionTask,
  fetchSubmissionTaskNextStatuses,
  getPublishedDocument,
  fetchHtml,
  downloadTaskHtmlAsPdf,
  fetchSlaAlerts,
};
